import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  name: null,
  email: null,
  phone: null,
  password: null, // We'll clear this after registration
  emailVerified: false,
  phoneVerified: false,
};

const registrationSlice = createSlice({
  name: 'registration',
  initialState,
  reducers: {
    setRegistrationData: (state, action) => {
      state.name = action.payload.name ?? null;
      state.email = action.payload.email;
      state.phone = action.payload.phone;
      state.password = action.payload.password;
      state.emailVerified = false;
      state.phoneVerified = false;
    },
    setEmailVerified: (state) => {
      state.emailVerified = true;
    },
    setPhoneVerified: (state) => {
      state.phoneVerified = true;
    },
    clearRegistrationData: (state) => {
      state.name = null;
      state.email = null;
      state.phone = null;
      state.password = null;
      state.emailVerified = false;
      state.phoneVerified = false;
    },
  },
});

export const { setRegistrationData, setEmailVerified, setPhoneVerified, clearRegistrationData } = registrationSlice.actions;

// Selectors
export const selectRegistrationData = (state) => state.registration;
export const selectEmail = (state) => state.registration.email;
export const selectPhone = (state) => state.registration.phone;

export default registrationSlice.reducer;
